import fileaxiosInstance from "api/fileAxiosInstance"
import SAlert from "components/Alert"
import { batch } from "react-redux"
import { adjustmentAction } from "./adjustment-slice"

export const getAdjustments =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null,
    advancedSearch = {}
  ) =>
  dispatch => {
    dispatch(adjustmentAction.setLoading(true))
    url = url || "/v1/adjustments"
    fileaxiosInstance
      .get(url, {
        params: {
          pageNumber,
          according,
          search,
          advancedSearch,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(adjustmentAction.setError(null))
            dispatch(adjustmentAction.setData(response.data))
            dispatch(adjustmentAction.setLoading(false))
          })
        }
      })
      .catch(error => {
        dispatch(adjustmentAction.setLoading(false))
        console.log(error)
      })
  }

export const getAdjustmentById = id => dispatch => {
  dispatch(adjustmentAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/adjustments/${id}`)
    .then(response => {
      batch(() => {
        dispatch(adjustmentAction.setAdjustment(response.data?.data))
        dispatch(adjustmentAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(adjustmentAction.setLoading(false))
    })
}

export const storeAdjustments = (formData, navigate) => dispatch => {
  dispatch(adjustmentAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/adjustments`, formData)
    .then(response => {
      dispatch(adjustmentAction.setLoading(false))
      SAlert({ text: "Inserted", status: "success" })
      navigate("/provider-adjustments")
    })
    .catch(error => {
      dispatch(adjustmentAction.setLoading(false))
      if (error?.response?.data) {
        dispatch(adjustmentAction.setError(error?.response?.data))
      }
    })
}

export const updateAdjustment = (id, formData, navigate) => dispatch => {
  dispatch(adjustmentAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/adjustments/${id}`, formData)
    .then(response => {
      dispatch(adjustmentAction.setLoading(false))
      SAlert({ text: "Updated", status: "success" })
      navigate("/provider-adjustments")
    })
    .catch(error => {
      dispatch(adjustmentAction.setLoading(false))
      if (error?.response?.data) {
        dispatch(adjustmentAction.setError(error?.response?.data))
      }
    })
}

export const deleteAdjustment = id => dispatch => {
  dispatch(adjustmentAction.setLoading(true))
  fileaxiosInstance
    .delete(`/v1/adjustments/${id}`)
    .then(response => {
      dispatch(adjustmentAction.setLoading(false))
      SAlert({ text: "Deleted", status: "success" })
      dispatch(getAdjustments())
    })
    .catch(error => {
      dispatch(adjustmentAction.setLoading(false))
      // Handle validation error from backend
      if (error?.response?.status === 422 && error?.response?.data?.message) {
        SAlert({ 
          text: error.response.data.message, 
          status: "error" 
        })
      } else {
        SAlert({ 
          text: "Failed to delete adjustment", 
          status: "error" 
        })
      }
    })
}

export const getAdjustmentReceipts =
  ({ itemId, submitionDate, adjustmentType }) =>
  dispatch => {
    dispatch(adjustmentAction.setReceiptsLoading(true))
    fileaxiosInstance
      .get(`/v1/get-adjustment-receipts`, {
        params: { itemId, submitionDate, adjustmentType },
      })
      .then(response => {
        batch(() => {
          dispatch(adjustmentAction.setReceipts(response.data))
          dispatch(adjustmentAction.setReceiptsLoading(false))
          dispatch(adjustmentAction.setReceiptsError(null))
        })
      })
      .catch(error => {
        dispatch(adjustmentAction.setReceiptsLoading(false))
        dispatch(adjustmentAction.setReceiptsError(error))
      })
  }

// Multi delete
export const deleteManyAdjustments = ids => dispatch => {
  dispatch(adjustmentAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/adjustments/delete/adjustments`, { ids })
    .then(response => {
      dispatch(adjustmentAction.setLoading(false))
      SAlert({ text: "Deleted", status: "success" })
      dispatch(getAdjustments())
    })
    .catch(error => {
      dispatch(adjustmentAction.setLoading(false))
      // Handle validation error from backend
      if (error?.response?.status === 422 && error?.response?.data) {
        const errorData = error.response.data
        if (errorData.invalid_adjustments && errorData.invalid_adjustments.length > 0) {
          const itemsList = errorData.invalid_adjustments.map(
            inv => `${inv.item} (Batch: ${inv.batch}, Balance: ${inv.current_balance}, Adjustment: ${inv.adjustment_qty})`
          ).join(", ")
          SAlert({ 
            text: `${errorData.message} Items: ${itemsList}`, 
            status: "error" 
          })
        } else {
          SAlert({ 
            text: errorData.message || "Cannot delete adjustments", 
            status: "error" 
          })
        }
      } else {
        SAlert({ 
          text: "Failed to delete adjustments", 
          status: "error" 
        })
      }
    })
}

// Export
export const exportAdjustments =
  (pageNumber, according, search, advancedSearch) => dispatch => {
    dispatch(adjustmentAction.setExportStatus({ loading: true, error: null }))
    fileaxiosInstance
      .get(`/v1/get-adjustment-export`, {
        params: { pageNumber, according, search, advancedSearch },
        responseType: "blob",
      })
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `Adjustments-${Date.now()}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        dispatch(
          adjustmentAction.setExportStatus({ loading: false, error: null })
        )
      })
      .catch(error => {
        dispatch(
          adjustmentAction.setExportStatus({ loading: false, error: error })
        )
      })
  }
